<script>

export let data;

</script>

<h2 class="text-xl lg:text-3xl font-semibold uppercase tracking-wide lg:leading-tight">Info</h2>
<p class="text-lg text-center">Provide Your Info</p>

{#if data}
<div class="flex flex-col gap-2 w-full max-w-[800px]">
	<div class="flex flex-col gap-2 lg:flex-row">
		<input bind:value={data.first_name} class="w-full px-3 py-2 border rounded border-dark border-opacity-10" placeholder="First Name" >
		<input bind:value={data.last_name} class="w-full px-3 py-2 border rounded border-dark border-opacity-10" placeholder="Last Name" >
	</div>

	<div class="flex flex-col gap-2 lg:flex-row">
		<input bind:value={data.email} class="w-full px-3 py-2 border rounded border-dark border-opacity-10" placeholder="Email Address" >
		<input bind:value={data.phone} class="w-full px-3 py-2 border rounded border-dark border-opacity-10" placeholder="Phone Number" >
	</div>

	<input bind:value={data.address} class="w-full px-3 py-2 border rounded border-dark border-opacity-10" placeholder="Address" >
	<textarea bind:value={data.message} class="w-full px-3 py-2 border rounded border-dark border-opacity-10" placeholder="Message [optional]" ></textarea>
</div>
{/if}
